import { inject } from '@angular/core';
import type { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../auth/services/auth.service';
import { isPublicApiEndpoint } from '../constants/public-endpoints';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const authService = inject(AuthService);

  if (
    !req.url.includes('login') &&
    !req.url.includes('register') &&
    !isPublicApiEndpoint(req.url)
  ) {
    req = req.clone({
      setHeaders: {
        Authorization: authService.getAuthHeader()
      }
    });
  }

  return next(req);
};
